import { render, staticRenderFns } from "./Freee.vue?vue&type=template&id=30577002&"
import script from "./Freee.vue?vue&type=script&lang=js&"
export * from "./Freee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports